import {
    BUSTYLE_KEY,
} from '../config';
import { BU_TYPE, BuTypeValue } from '@src/slide/domain/ui-model/element-modeles/property/text/constants';
import typeExpect from '@src/slide/infrastructure/module/independent/assert/expect';
import { paraStyleMerge } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/paragraph-style';
import { IParagraphCharacter, IParagraphStyle } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';
import { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';


export function getBuType(paragraphStyle: IParagraphCharacter): BuTypeValue {
    if (!typeExpect(paragraphStyle.buNone).isNullOrUndefined()) return BU_TYPE.NONE;
    if (paragraphStyle.buFont) return BU_TYPE.BULLET_CHAR;
    if (paragraphStyle.buAutoNum) return BU_TYPE.AUTO_NUM;
    if (paragraphStyle.buBlip) return BU_TYPE.BLIP;
    return BU_TYPE.INHERIT;
}


export function mergeParagraphListStyle(
    paragraphList: IParagraph[],
    paraStyle: IParagraphStyle,
    start: number,
    end: number,
): any[] {
    const pL: IParagraph[] = JSON.parse(JSON.stringify(paragraphList));
    for (let i: number = start; i <= end; i++) {
        const paragraphProps: any = paraStyleMerge(pL[i] && {
            ...pL[i].paragraphProps,
            ...(
                // 老版本的model中paragraphProps包含paragraphCharacter，canvas版本不包含，这里兼容下
                pL[i].paragraphCharacter
            ),
        }, paraStyle);
        const paragraphCharacter: IParagraphCharacter = BUSTYLE_KEY
            .reduce((prevParam: IParagraphCharacter, key: string) => {
                const prev: IParagraphCharacter = prevParam;
                if (!typeExpect(paragraphProps[key]).isNullOrUndefined()) prev[key] = paragraphProps[key];
                return prev;
            }, {});

        pL[i] = {
            ...pL[i],
            paragraphProps,
            paragraphCharacter,
        };
    }

    return pL;
}
